import type { UpsertInventoryValueInput } from "@/graphql/generated/graphql";

export type CommandType = "INSERT_ROWS" | "DELETE_ROWS";

export interface Command {
  type: CommandType;
  payload: unknown;
  tempId: string;
  inventoryId: string;
  timestamp: number;
}

export interface InsertRowsCommandPayload {
  rows: UpsertInventoryValueInput[];
  tempIdToRowIndex?: Record<string, number>; // Map temp-id to row index for squashing deletes
  rowToTempId?: Map<number, string>; // Map row index to temp-id for sending to backend
}

export interface DeleteRowsCommandPayload {
  rowIds: string[];
}

export class InsertRowsCommand implements Command {
  type: CommandType = "INSERT_ROWS";
  tempId: string;
  timestamp: number;
  inventoryId: string;

  constructor(public payload: InsertRowsCommandPayload, inventoryId: string) {
    this.tempId = `temp-${Date.now()}-${Math.random()}`;
    this.timestamp = Date.now();
    this.inventoryId = inventoryId;
  }
}

export class DeleteRowsCommand implements Command {
  type: CommandType = "DELETE_ROWS";
  tempId: string;
  timestamp: number;
  inventoryId: string;

  constructor(public payload: DeleteRowsCommandPayload, inventoryId: string) {
    this.tempId = `temp-${Date.now()}-${Math.random()}`;
    this.timestamp = Date.now();
    this.inventoryId = inventoryId;
  }
}

